import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DirectivesModule } from '@freelancer/directives';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { UserProfileEditableUiActionRowRedesignComponent } from './user-profile-editable-ui-action-row-redesign/user-profile-editable-ui-action-row-redesign.component';

@NgModule({
  imports: [CommonModule, DirectivesModule, UiModule, TrackingModule],
  declarations: [UserProfileEditableUiActionRowRedesignComponent],
  exports: [UserProfileEditableUiActionRowRedesignComponent],
})
export class UserProfileEditableUiRedesignModule {}
